
const digest = 'f07d43b4d3457983cc506ed607d2e5710e09cf3a30afc0bc640196c04e641f38';
const classes = {"p":"_p_11hkh_1"};
const css = `._p_11hkh_1 {
  font-family: Rubik, "sans-serif";
  margin: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  